export default __webpack_public_path__ + "fonts/check-circle-Teal.svg";